import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable
} from "@tanstack/react-table";
import { NoData } from "views/renters/components/Table/RowDrawer/components/NoData";
import { columnsForLedgerTable } from "views/renters/components/Table/constants";
import { AlgoliaUser } from "views/renters/types";

type Props = {
  selectedRowData: AlgoliaUser;
};

export const PMSLedger = ({ selectedRowData }: Props) => {
  const table = useReactTable({
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    data: selectedRowData.transactions || [],
    columns: columnsForLedgerTable as ColumnDef<any, any>[],
    getCoreRowModel: getCoreRowModel()
  });

  return selectedRowData.transactions.length > 0 ? (
    <table className="w-full p-4">
      <thead className="justify-between text-xs text-content-300">
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th
                key={header.id}
                className="px-3.5 py-4 text-start first:px-0 first:text-left last:px-0 last:text-end"
                style={{ width: `${header.getSize()}px` }}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td
                key={cell.id}
                className="px-4 py-3.5 text-sm first:px-0 last:px-0 last:text-end"
                style={{ maxWidth: `${cell.column.getSize()}px` }}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <NoData />
  );
};
